import AnimateHeight from 'react-animate-height'
import PropTypes from 'prop-types'
import React, {Fragment, useState} from 'react'
import classNames from 'classnames'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as addToLookActions from '../../actions/addToLook'
import * as looksSelectors from '../../store/looks'
import * as pdpSelectors from '../../store/productDetailPage'
import * as productSelectors from '../../store/product'
import * as track from '../../track/other'
import * as URLS from '../../urls'
import * as userSelectors from '../../store/user'

import {getDecimalDollarFormat} from '../../utils'
import {TRANSACTION_TYPE_BUY, TRANSACTION_TYPE_RENT} from '../../const'

import AddToLookButton from './AddToLookButton'
import TransactionTypeButton from './TransactionTypeButton'

import '../../../scss/pages/pdp/_pdp-revamp-section.scss'

const PdpRevampSection = ({
  addProductsToLookbuilder,
  buyPrice,
  hasLooks,
  isAuthenticated,
  isPurchasable,
  productSlug,
  recommendedItems,
  rentPrice,
}) => {
  const [accordionIsOpen, setAccordionIsOpen] = useState(false)
  const recommendedItemsSlugs = recommendedItems.map(({slug}) => slug)
  const productSlugs = [...recommendedItemsSlugs, productSlug]

  return (
    <div className="pdp-revamp-section">
      <div className="pdp-revamp-section__prices">
        {rentPrice && (
          <span className="pdp-revamp-section__rent-price">
            Rent {getDecimalDollarFormat(rentPrice)}
          </span>
        )}
        {isPurchasable && (
          <span className="pdp-revamp-section__buy-price">
            Buy {getDecimalDollarFormat(buyPrice)}
          </span>
        )}
      </div>
      <button
        className="pdp-revamp-section__customize-look-button"
        onClick={() => {
          addProductsToLookbuilder(productSlugs)
          track.clickedLink({
            location: 'pdp',
            target: URLS.LOOKBUILDER,
            text: 'Customize This Look',
            type: 'link',
          })
        }}
        type="button"
      >
        Customize This Look
      </button>
      {isAuthenticated && hasLooks && (
        <Fragment>
          <button
            className={classNames('pdp-revamp-section__add-saved-look-button', {
              'is--open': accordionIsOpen,
            })}
            onClick={() => {
              setAccordionIsOpen(!accordionIsOpen)
              track.clickedLink({
                location: 'pdp',
                text: 'Add To Saved Look',
                type: 'button',
              })
            }}
            type="button"
          >
            Add To Saved Look
          </button>
          <AnimateHeight height={accordionIsOpen ? 'auto' : 0}>
            <div className="pdp-revamp-section__accordion">
              <p className="pdp-revamp-section__accordion-choice">1. Choose One</p>
              <div className="pdp-revamp-section__accordion-buttons">
                <TransactionTypeButton transactionType={TRANSACTION_TYPE_RENT} />
                <TransactionTypeButton transactionType={TRANSACTION_TYPE_BUY} />
              </div>
              <AddToLookButton buttonText="2. Select A Look" modifier="pdp-revamp" />
            </div>
          </AnimateHeight>
        </Fragment>
      )}
    </div>
  )
}

PdpRevampSection.propTypes = {
  addProductsToLookbuilder: PropTypes.func.isRequired,
  buyPrice: PropTypes.string,
  hasLooks: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isPurchasable: PropTypes.bool.isRequired,
  productSlug: PropTypes.string.isRequired,
  recommendedItems: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
    }),
  ).isRequired,
  rentPrice: PropTypes.string,
}

const mapStateToProps = createStructuredSelector({
  buyPrice: pdpSelectors.productBuyPrice,
  hasLooks: looksSelectors.hasNonHtoLooks,
  isAuthenticated: userSelectors.isAuthenticated,
  isPurchasable: pdpSelectors.productIsPurchasable,
  productSlug: pdpSelectors.productUrlSlug,
  recommendedItems: productSelectors.sortedRecommendedItems,
  rentPrice: pdpSelectors.productRentPrice,
})

const mapDispatchToProps = {
  addProductsToLookbuilder: addToLookActions.addProductsToLookbuilder,
}

export default connect(mapStateToProps, mapDispatchToProps)(PdpRevampSection)
